import React from 'react'
import { tabs } from './tabs'
import './index.css'
import { TabList } from '../../ui'
import { RoundCard, RunnerUpHeader, TableWork, UnderLine } from '../../ui'
import { useGetAllNullificationQuery } from '../../services/nullificationservice'
import Pendingrequest from './PendingRequest'
import LeftMenu from '../AnalyticsModule/Left'
import RunnerUpHeaderNew from '../../ui/runnerUpHeader/RunnerUpHeaderNew'

const Approvenullificationrequests = (props) => {
  const { data } = useGetAllNullificationQuery()

  const tabs = [
    {
      key: '1',
      label: 'All',
      count: '0',
      content: <Pendingrequest />,
    },
    {
      key: '2',
      label: 'Pending',
      count: data?.payload?.totalPendingCount,
      content: <Pendingrequest label={'show'} value={'Pending'} />,
    },
    {
      key: '3',
      label: 'Accepted',
      count: '0',
      content: <Pendingrequest value={'Approved'} />,
    },
    {
      key: '4',
      label: 'Rejected',
      count: '0',
      content: <Pendingrequest value={'Rejected'} />,
    },
  ]

  return (
    <LeftMenu>
      <div className="nullification-tabs">
        <div className="container-fluid box shadow ">
          <RunnerUpHeaderNew title="Approve Nullification Requests" />
          <TabList
            tabList={tabs}
            defaultActiveKey={2}
            badge={true}
            tabClass="mb-3 tab-list"
            badgeClass="badge"
          />
        </div>
      </div>
    </LeftMenu>
  )
}

export default Approvenullificationrequests
